var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeparture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "mmyafza4ja",
    cx: 8,
    cy: 8,
    r: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "44c2r2waqb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mmyafza4ja"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#477AFE",
    xlinkHref: "#mmyafza4ja"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.218 12.526a.227.227 0 0 0-.192.128.246.246 0 0 0 .01.237.224.224 0 0 0 .203.109h9.53a.225.225 0 0 0 .2-.118.246.246 0 0 0 0-.239.225.225 0 0 0-.2-.117H3.219z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.64,
    mask: "url(#44c2r2waqb)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#44c2r2waqb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-21 20.489 2.802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .957.691-.03 1.333 1.651 6.717-.11a86.275 86.275 0 0 1 2.401-.016c.637.031 1.43.495 1.693.639.29.159.24.63-.486.773l-.204.036c-.614.1-1.781.21-3.565.169L5.405 6l-.6-.19-.17-.592.275.06.176.166 1.309-1.489-.234-.018-1.49-.131C2.167 3.57.654 3.357.654 3.357L0 .957zM3.354 0l.197.078.291.534 3.282 1.66-1.96.031L3.499.85 3.354 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.823 4.234h.816V4.03l-.816.021z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M10.231 4.233v.254"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 10.25,
    cy: 4.55,
    r: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeparture);
export default __webpack_public_path__ + "static/media/icon-departure.009a1e463fcb3af25d643eed655edc52.svg";
export { ForwardRef as ReactComponent };